import React from 'react';
import PropTypes from 'prop-types';

const BreadcrumbsItem = ({ link, title, position }) =>
  link ? (
    <li
      itemScope
      itemProp="itemListElement"
      itemType="http://schema.org/ListItem"
    >
      <a href={link} itemProp="item" className="lt-link">
        <span itemProp="name">{title}</span>
      </a>
      <meta content={position} itemProp="position" />
    </li>
  ) : (
    <li>{title}</li>
  );

BreadcrumbsItem.defaultProps = {
  link: null,
};

BreadcrumbsItem.propTypes = {
  link: PropTypes.string,
  title: PropTypes.string.isRequired,
  position: PropTypes.number.isRequired,
};

export default BreadcrumbsItem;
